import { Store, useStore } from '@tanstack/react-store';

type OnboardingState = {
  isOpen: boolean;
  activeStep: number;
  /** The first-run opening happens once per session, even if saving the completion failed. */
  hasAutoOpened: boolean;
};

const onboardingStore = new Store<OnboardingState>({ isOpen: false, activeStep: 0, hasAutoOpened: false });

/** Always starts over from the first step. */
export function openOnboarding() {
  onboardingStore.setState((state) => ({ ...state, isOpen: true, activeStep: 0 }));
}

export function autoOpenOnboarding() {
  if (!onboardingStore.state.hasAutoOpened) {
    onboardingStore.setState((state) => ({ ...state, isOpen: true, activeStep: 0, hasAutoOpened: true }));
  }
}

export function closeOnboarding() {
  onboardingStore.setState((state) => ({ ...state, isOpen: false }));
}

export function setOnboardingStep(activeStep: number) {
  onboardingStore.setState((state) => ({ ...state, activeStep }));
}

export function useIsOnboardingOpen() {
  return useStore(onboardingStore, (state) => state.isOpen);
}

export function useOnboardingActiveStep() {
  return useStore(onboardingStore, (state) => state.activeStep);
}

export function useHasOnboardingAutoOpened() {
  return useStore(onboardingStore, (state) => state.hasAutoOpened);
}
